export default __webpack_public_path__ + "media/zurb/img/home/home-work-darby-e1eb82f00b97f9e5c9b45ff7a9d62013.png";